module.exports = __webpack_public_path__ + "4f62b81ff327bd0ffadcb7b82e6c13b2.woff";